import { render } from "./OutsideComponent.vue?vue&type=template&id=77caf24f&scoped=true"
import script from "./OutsideComponent.vue?vue&type=script&lang=js"
export * from "./OutsideComponent.vue?vue&type=script&lang=js"

import "./OutsideComponent.vue?vue&type=style&index=0&id=77caf24f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\anton\\Desktop\\cangas_de_narcea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77caf24f"]])

export default __exports__